import { CommandProcessor } from '@/api/CommandProcessor'
import { Command } from 'lime-js'
import { store } from '@/store'
import { BlipAccount } from '../models/BlipAccount'
import { BOT_DOMAIN, DOMAIN } from '../settings'

export class AccountCommandProcessor {
  static get(identifier: string, domain: string = BOT_DOMAIN): Command {

    return CommandProcessor.processCommand({
      method: 'get',
      to: `postmaster@${domain}`,
      uri: `lime://${domain}/accounts/${identifier}`,
    })
  }

  static create(identifier: string, resource: BlipAccount): Command {
    const client = store.getters.instance

    return CommandProcessor.processCommand({
      method: 'set',
      from: `${identifier}@${DOMAIN}/default`,
      pp: client._clientChannel.localNode,
      type: 'application/vnd.lime.account+json',
      uri: '/account',
      resource,
    })
  }

  static async update(account: BlipAccount): Promise<Command> {
    const client = store.getters.instance
    const localNode = client._clientChannel.localNode
    const [identifier, domain] = localNode.split('@')

    let currentAccount
    try {
      const { resource } = await this.get(identifier, domain.split('/')[0])
      currentAccount = resource
    } catch (e) {
      currentAccount = {}
    }

    const mergedAccount = { ...currentAccount, ...account }

    return CommandProcessor.processCommandWithRetry({
      method: 'merge',
      type: 'application/vnd.lime.account+json',
      uri: '/account',
      resource: mergedAccount,
    })
  }

  static getAccountStatus(identifier: string, domain: string = BOT_DOMAIN): Command {
    return CommandProcessor.processCommand({
      method: 'get',
      to: `postmaster@${domain}`,
      uri: `lime://${domain}/accounts/${identifier}/active`,
    })
  }

  static async status(identity: string): Promise<string> {

    try {
      await CommandProcessor.processCommand({
        method: 'get',
        uri: '/ping',
        to: `${identity}@${BOT_DOMAIN}`,
      })

      return 'online'
    } catch (e) {
      return 'offline'
    }
  }

  static welcomeMessage(identifier: string): Command {

    return CommandProcessor.processCommand({
      method: 'get',
      to: `postmaster@${BOT_DOMAIN}`,
      uri: `lime://${identifier}@${BOT_DOMAIN}/profile/greeting`,
    })
  }
  static startButton(identifier: string): Command {

    return CommandProcessor.processCommand({
      method: 'get',
      to: `postmaster@${BOT_DOMAIN}`,
      uri: `lime://${identifier}@${BOT_DOMAIN}/profile/get-started`,
    })
  }
  static startButtonLabel(identifier: string): Command {

    return CommandProcessor.processCommand({
      method: 'get',
      to: `postmaster@${BOT_DOMAIN}`,
      uri: `lime://${identifier}@${BOT_DOMAIN}/profile/get-started-label`,
    })
  }

  static setPresence(status: string, routingRule?: string) {

    return CommandProcessor.processCommand({
      method: 'set',
      uri: '/presence',
      type: 'application/vnd.lime.presence+json',
      resource: routingRule ? { status, routingRule, echo: true } : { status },
    })
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/api/AccountCommandProcessor.ts